import '@app/App.css';
import { CompozzObjectViewSpinner } from '@comps/ui/CompozzSpinner';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@comps/ui/resizable';
import { Skeleton } from '@comps/ui/skeleton';
import { TW_App, TW_AppMain, TW_AppSidebarObject, TW_AppSidebarSkeleton, TW_AppSidebarViewSkeleton } from '@utils/twClasses';
import HomeHeader from './HomeHeader';


function LoadingWorkspaceSection() {

  return (
    <div className={TW_App}>
      <HomeHeader />
      <ResizablePanelGroup className={TW_AppMain} direction="horizontal">
        <ResizablePanel defaultSize={10}>
          <div className={TW_AppSidebarSkeleton}>
            <Skeleton className={TW_AppSidebarObject} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarObject + " mt-4"} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarObject + " mt-4"} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarObject + " mt-4"} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
            <Skeleton className={TW_AppSidebarViewSkeleton} />
          </div>
        </ResizablePanel>
        <ResizableHandle />
        <ResizablePanel defaultSize={90}>
          <CompozzObjectViewSpinner />
          {/* <div className={TW_AppObjectModelViewSkeleton}>
            <Skeleton className={TW_AppObjectHeaderSkeleton} />
            {Array.from({ length: 30 }).map((_, i) => (
              <div key={"skeleton-line-" + i} className={TW_AppObjectLineSkeleton}>
                {Array.from({ length: 10 }).map((_, j) => (
                  <Skeleton key={"skeleton-cell-" + i + "-" + j} className={TW_AppObjectCellSkeleton} />
                ))}
              </div>
            ))
            }
          </div>
          <div className="flex justify-center items-center h-full w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <CompozzSpinner />
          </div> */}
        </ResizablePanel>
      </ResizablePanelGroup>

    </div>
  );

};

export default LoadingWorkspaceSection;